module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingstatus),
      expression: "loadingstatus"
    }],
    staticClass: "float-e-margins grey_box ibox_main",
    attrs: {
      "id": "subPage",
      "element-loading-text": "加载中"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal ibox-content"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label focus_color"
  }, [_vm._v("*组织机构名称")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    class: {
      'form-group--error': _vm.$v.orgName.$error
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.orgName),
      expression: "orgName",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control ",
    attrs: {
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.orgName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.orgName = $event.target.value.trim()
      }, function($event) {
        return _vm.$v.orgName.$touch()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.$v.orgName.required && _vm.$v.orgName.$error) ? _c('span', {
    staticClass: "cus_message form-group__message"
  }, [_vm._v("组织机构名称为必填项")]) : _vm._e()]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label focus_color"
  }, [_vm._v("*英文简称")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    class: {
      'form-group--error': _vm.$v.shortName.$error
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.shortName),
      expression: "shortName",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.shortName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.shortName = $event.target.value.trim()
      }, function($event) {
        return _vm.$v.shortName.$touch()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.$v.shortName.required && _vm.$v.shortName.$error) ? _c('span', {
    staticClass: "form-group__message cus_message"
  }, [_vm._v("必填")]) : _vm._e(), _vm._v(" "), (!_vm.$v.shortName.isEngChar) ? _c('span', {
    staticClass: "form-group__message cus_message"
  }, [_vm._v("只能包含英文字母,数字,下划线,中划线和小数点,长度在2~20之间")]) : _vm._e()]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("机构管理方")]), _vm._v(" "), (_vm.isAdmin != 9 || _vm.curMode != 'new') ? _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curParentName),
      expression: "curParentName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.curParentName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.curParentName = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isAdmin == 9 && _vm.curMode == 'new') ? _c('div', {
    staticClass: "col-sm-3"
  }, [_c('select2', {
    attrs: {
      "options": _vm.superAdminCustomerList
    },
    model: {
      value: (_vm.selectCustomerId),
      callback: function($$v) {
        _vm.selectCustomerId = $$v
      },
      expression: "selectCustomerId"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label focus_color"
  }, [_vm._v("*顺序号")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    class: {
      'form-group--error': _vm.$v.orderNo.$error
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.orderNo),
      expression: "orderNo",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.orderNo)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.orderNo = $event.target.value.trim()
      }, function($event) {
        return _vm.$v.orderNo.$touch()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.$v.orderNo.required && _vm.$v.orderNo.$error) ? _c('span', {
    staticClass: "form-group__message cus_message"
  }, [_vm._v("顺序号为必填项")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "col-sm-8 control-label gray t_left"
  }, [_vm._v("建议以10为间隔设置组织机构的顺序号。如10、20、30等。")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("联系人")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orgPerson),
      expression: "orgPerson"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.orgPerson)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orgPerson = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("联系电话")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orgTel),
      expression: "orgTel"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.orgTel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orgTel = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.isAdmin != 0 && _vm.levv != 3) ? _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("派单权重")]) : _vm._e(), _vm._v(" "), (_vm.isAdmin != 0 && _vm.levv != 3) ? _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.authRatio),
      expression: "authRatio"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.authRatio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.authRatio = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.rightRatio) ? _c('p', {
    staticClass: "red help-block"
  }, [_vm._v("请输入0-100的整数")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("组织机构地址")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-11"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orgAdd),
      expression: "orgAdd"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "250"
    },
    domProps: {
      "value": (_vm.orgAdd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orgAdd = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.curMode == 'new') ? _c('div', {
    staticClass: "form-group mt10px"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label focus_color"
  }, [_vm._v("*管理员帐号")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    class: {
      'form-group--error': _vm.$v.account.$error
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.account),
      expression: "account",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.account)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.account = $event.target.value.trim()
      }, function($event) {
        return _vm.$v.account.$touch()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s(_vm.shortName ? '@' : '') + _vm._s(_vm.shortName))])]), _vm._v(" "), (!_vm.$v.account.required && _vm.$v.account.$error) ? _c('span', {
    staticClass: "cus_message form-group__message"
  }, [_vm._v("必填")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "col-sm-8 control-label gray t_left"
  }, [_vm._v("管理员登录时，使用“管理员账号”+@+“机构英文简称”作为登录名称。")])]) : _vm._e(), _vm._v(" "), (_vm.curMode == 'new') ? _c('div', {
    staticClass: "form-group mt10px"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    class: {
      'form-group--error': _vm.$v.password.$error
    },
    staticStyle: {
      "position": "relative"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      }, function($event) {
        return _vm.$v.password.$touch()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.$v.password.required && _vm.$v.password.$error) ? _c('span', {
    staticClass: "form-group__message cus_message"
  }, [_vm._v("必填")]) : _vm._e(), _vm._v(" "), (!_vm.$v.password.maxLength || !_vm.$v.password.minLength) ? _c('span', {
    staticClass: "form-group__message cus_message"
  }, [_vm._v("长度在6~30之间")]) : _vm._e()]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    class: {
      'form-group--error': _vm.$v.passwordConfirm.$error
    },
    staticStyle: {
      "position": "relative"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.passwordConfirm),
      expression: "passwordConfirm",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.passwordConfirm)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordConfirm = $event.target.value.trim()
      }, function($event) {
        return _vm.$v.passwordConfirm.$touch()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.$v.passwordConfirm.sameAsPassword && _vm.$v.passwordConfirm.$error) ? _c('span', {
    staticClass: "form-group__message cus_message"
  }, [_vm._v("两次密码不一致")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    class: {
      'form-group--error': _vm.$v.maxNum.$error
    }
  }, [(_vm.curMode == 'new') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.maxNum),
      expression: "maxNum",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.maxNum)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.maxNum = $event.target.value.trim()
      }, function($event) {
        return _vm.$v.maxNum.$touch()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curMode == 'detail') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.maxNum),
      expression: "maxNum",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.maxNum)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.maxNum = $event.target.value.trim()
      }, function($event) {
        return _vm.$v.maxNum.$touch()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curMode == 'edit') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.maxNum),
      expression: "maxNum",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": _vm.orgInfo.customerId == _vm.curCustomerId
    },
    domProps: {
      "value": (_vm.maxNum)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.maxNum = $event.target.value.trim()
      }, function($event) {
        return _vm.$v.maxNum.$touch()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.curMode == 'new' && _vm.isAdmin == 9 && _vm.selectCustomerId == 1) ? _c('p', {
    staticClass: "help-block"
  }, [_vm._v("最小值为:0")]) : _vm._e(), _vm._v(" "), (_vm.curMode == 'new' && _vm.isAdmin != 9 && _vm.curParentId == 1) ? _c('p', {
    staticClass: "help-block"
  }, [_vm._v("最小值为:0")]) : _vm._e(), _vm._v(" "), (_vm.curMode == 'edit' && _vm.curParentId == 1) ? _c('p', {
    staticClass: "help-block"
  }, [_vm._v("最小值为:" + _vm._s(_vm.carMinMount))]) : _vm._e(), _vm._v(" "), (_vm.curMode == 'new' && _vm.isAdmin == 9 && _vm.selectCustomerId != 1) ? _c('p', {
    staticClass: "help-block"
  }, [_vm._v("设置范围：0-" + _vm._s(_vm.carMaxMount))]) : _vm._e(), _vm._v(" "), (_vm.curMode == 'edit' && _vm.isAdmin == 9 && _vm.curParentId != 1 && _vm.orgInfo.customerId != _vm.curCustomerId) ? _c('p', {
    staticClass: "help-block"
  }, [_vm._v("设置范围：" + _vm._s(_vm.carMinMount) + "-" + _vm._s(_vm.carMaxMount))]) : _vm._e(), _vm._v(" "), (_vm.curMode == 'new' && _vm.isAdmin != 9 && _vm.curParentId != 1) ? _c('p', {
    staticClass: "help-block"
  }, [_vm._v("设置范围：0-" + _vm._s(_vm.carMaxMount))]) : _vm._e(), _vm._v(" "), (_vm.curMode == 'edit' && _vm.isAdmin != 9 && _vm.curParentId != 1 && _vm.orgInfo.customerId != _vm.curCustomerId) ? _c('p', {
    staticClass: "help-block"
  }, [_vm._v("设置范围：" + _vm._s(_vm.carMinMount) + "-" + _vm._s(_vm.carMaxMount))]) : _vm._e(), _vm._v(" "), (!_vm.$v.maxNum.required && _vm.$v.maxNum.$error) ? _c('span', {
    staticClass: "form-group__message cus_message"
  }, [_vm._v("必填")]) : _vm._e(), _vm._v(" "), (!_vm.$v.maxNum.numForm) ? _c('span', {
    staticClass: "form-group__message cus_message"
  }, [_vm._v("请输入大于等于0的数字")]) : _vm._e(), _vm._v(" "), (!_vm.correctNum) ? _c('span', {
    staticClass: "form-group__message cus_message"
  }, [_vm._v("不要超出平台挂车范围")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 pt10px"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_c('checkbox', {
    model: {
      value: (_vm.isShowTest),
      callback: function($$v) {
        _vm.isShowTest = $$v
      },
      expression: "isShowTest"
    }
  }, [_vm._v("是否显示测试车辆")])], 1)]), _vm._v(" "), (_vm.isAdmin != 0 && _vm.levv != 3) ? _c('div', {
    staticClass: "col-sm-2 pt10px"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_c('checkbox', {
    model: {
      value: (_vm.isMultiSent),
      callback: function($$v) {
        _vm.isMultiSent = $$v
      },
      expression: "isMultiSent"
    }
  }, [_vm._v("是否允许“一车多单”")])], 1)]) : _vm._e(), _vm._v(" "), ((_vm.isAdmin == 1 || _vm.isAdmin == 9) && _vm.groupId == 1) ? _c('div', {
    staticClass: "col-sm-3 pt10px"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_c('checkbox', {
    model: {
      value: (_vm.serviceFlag),
      callback: function($$v) {
        _vm.serviceFlag = $$v
      },
      expression: "serviceFlag"
    }
  }, [_vm._v("是否关闭接单权限")])], 1)]) : _vm._e()]), _vm._v(" "), (_vm.levv == 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label focus_color"
  }, [_vm._v("车辆树显示1")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tree1),
      expression: "tree1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tree1 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.tempList1), function(tree) {
    return _c('option', {
      domProps: {
        "value": tree.udccode
      }
    }, [_vm._v(_vm._s(tree.udcname))])
  }), 0)]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("车辆树显示2")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tree2),
      expression: "tree2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tree2 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.tempList2), function(tree) {
    return _c('option', {
      domProps: {
        "value": tree.udccode
      }
    }, [_vm._v(_vm._s(tree.udcname))])
  }), 0)]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("车辆树显示3")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tree3),
      expression: "tree3"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tree3 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.tempList3), function(tree) {
    return _c('option', {
      domProps: {
        "value": tree.udccode
      }
    }, [_vm._v(_vm._s(tree.udcname))])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.curMode !== 'detail') ? _c('div', {
    staticClass: "form-group"
  }, [(_vm.isAdmin == 9 && _vm.selectCustomerId == 1 && _vm.curMode == 'new') ? _c('div', [(_vm.versionArr.length != 0) ? _c('label', {
    staticClass: "col-sm-1 control-label red"
  }, [_vm._v("授权版本")]) : _vm._e(), _vm._v(" "), (_vm.versionArr.length != 0) ? _c('div', {
    staticClass: "col-sm-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.licenceId),
      expression: "licenceId",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.licenceId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.$v.licenceId.$touch()
      }]
    }
  }, _vm._l((_vm.versionArr), function(version) {
    return _c('option', {
      domProps: {
        "value": version.udccode
      }
    }, [_vm._v(_vm._s(version.udcname))])
  }), 0), _vm._v(" "), (!_vm.$v.licenceId.required && _vm.$v.licenceId.$error) ? _c('span', {
    staticClass: "form-group__message cus_message"
  }, [_vm._v("授权版本为必填项")]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.curMode == 'new' && _vm.isAdmin != 9 && _vm.curParentId == 1) ? _c('div', [(_vm.versionArr.length != 0) ? _c('label', {
    staticClass: "col-sm-1 control-label red"
  }, [_vm._v("授权版本")]) : _vm._e(), _vm._v(" "), (_vm.versionArr.length != 0) ? _c('div', {
    staticClass: "col-sm-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.licenceId),
      expression: "licenceId",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.licenceId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.$v.licenceId.$touch()
      }]
    }
  }, _vm._l((_vm.versionArr), function(version) {
    return _c('option', {
      domProps: {
        "value": version.udccode
      }
    }, [_vm._v(_vm._s(version.udcname))])
  }), 0), _vm._v(" "), (!_vm.$v.licenceId.required && _vm.$v.licenceId.$error) ? _c('span', {
    staticClass: "form-group__message cus_message"
  }, [_vm._v("授权版本为必填项")]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.curMode == 'edit' && _vm.curParentId == 1) ? _c('div', [_c('label', {
    staticClass: "col-sm-1 control-label red"
  }, [_vm._v("授权版本")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licenceId),
      expression: "licenceId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.licenceId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.versionArr), function(version) {
    return _c('option', {
      domProps: {
        "value": version.udccode
      }
    }, [_vm._v(_vm._s(version.udcname))])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.isAdmin == 9 && _vm.curMode == 'new' && _vm.selectCustomerId != 1) ? _c('div', [_c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("功能设置")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.funcList.length > 0),
      expression: "funcList.length > 0"
    }],
    staticClass: "col-sm-5",
    staticStyle: {
      "margin-top": "0",
      "width": "250px",
      "height": "300px",
      "overflow": "auto"
    }
  }, [_c('ul', {
    staticClass: "ztree ztree-slide",
    attrs: {
      "id": "orgFuncTreeSet"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isAdmin != 9 && _vm.curMode == 'new' && _vm.curParentId != 1) ? _c('div', [_c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("功能设置")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.funcList.length > 0),
      expression: "funcList.length > 0"
    }],
    staticClass: "col-sm-5",
    staticStyle: {
      "margin-top": "0",
      "width": "250px",
      "height": "300px",
      "overflow": "auto"
    }
  }, [_c('ul', {
    staticClass: "ztree ztree-slide",
    attrs: {
      "id": "orgFuncTreeSet"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.curMode == 'edit' && _vm.curParentId != 1 && _vm.curCustomerId != _vm.orgInfo.customerId) ? _c('div', [_c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("功能设置")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.funcList.length > 0),
      expression: "funcList.length > 0"
    }],
    staticClass: "col-sm-5",
    staticStyle: {
      "margin-top": "0",
      "width": "250px",
      "height": "300px",
      "overflow": "auto"
    }
  }, [_c('ul', {
    staticClass: "ztree ztree-slide",
    attrs: {
      "id": "orgFuncTreeSet"
    }
  })])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal mt20px"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('label', {
    staticClass: "col-sm-1  control-label"
  }, [_vm._v("企业LOGO")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-11"
  }, [_c('div', {
    staticClass: "uploadedImg t_left col-sm-3"
  }, [(_vm.logoSrc == '') ? _c('img', {
    key: "noLogo",
    staticClass: "img-responsive",
    attrs: {
      "src": require("../../../assets/project/images/img_bg.jpg")
    }
  }) : _c('img', {
    key: "hasLogo",
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.logoSrc
    }
  })]), _vm._v(" "), _c('vue-core-image-upload', {
    class: ['upload-pic'],
    attrs: {
      "extensions": "png,gif,jpeg,jpg",
      "input-accept": "image/jpg,image/jpeg,image/png",
      "crop": false,
      "text": "",
      "inputOfFile": "file",
      "url": _vm.picUrl,
      "headers": {
        'access-token': this.accesstoken
      }
    },
    on: {
      "imageuploaded": _vm.imageuploaded
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "col-sm-7 control-label gray t_left"
  }, [_vm._v("请上传jpg、jpeg或png格式的图片")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal mt20px"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 text-right control-label"
  }, [_vm._v("备注")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-11"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note),
      expression: "note"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "1"
    },
    domProps: {
      "value": (_vm.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal mt20px",
    staticStyle: {
      "position": "relative",
      "bottom": "0"
    }
  }, [_c('div', {
    staticClass: "hr-line-dashed"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "hideWhenNew"
    }
  }, [_c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("创建人")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.createPerson),
      expression: "createPerson"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.createPerson)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.createPerson = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("创建时间")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.createTime),
      expression: "createTime"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.createTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.createTime = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("修改人")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.changePerson),
      expression: "changePerson"
    }],
    staticClass: "form-control change",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.changePerson)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.changePerson = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("修改时间")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.changeTime),
      expression: "changeTime"
    }],
    staticClass: "form-control change",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.changeTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.changeTime = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-primary col-sm-offset-5",
    attrs: {
      "disabled": !_vm.isDisable || !_vm.rightRatio
    },
    domProps: {
      "textContent": _vm._s(_vm.btnValue)
    },
    on: {
      "click": _vm.onSave
    }
  })])]), _vm._v(" "), _c('sub-modal', {
    ref: "modal2",
    attrs: {
      "size": "small",
      "title": "温馨提示"
    }
  }, [_c('p', {
    domProps: {
      "textContent": _vm._s(_vm.tipContent)
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.showWithdraw) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.withdrawSubBtn
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.confirmSubBtn
    }
  }, [_vm._v("确定")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-horizontal "
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('label', {
    staticClass: "col-sm-6  control-label t_left"
  }, [_vm._v("企业参数设定")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("*密码")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("*再次输入密码")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("*平台挂车最大数")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e1362fc","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/organise/PageOrganiseEdit.vue
// module id = 1462
// module chunks = 0